import { db } from "../firebase/config";
import { collection, getDocs } from "firebase/firestore";

export const carsLoader = async () => {
  let results = [];
  const querySnapshot = await getDocs(collection(db, "cars"));
  querySnapshot.forEach((doc) => {
    results.push({ id: doc.id, ...doc.data() });
  });
  return results;
};
